import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { notForPreview } from 'widget/utils/not-for-preview';

import { playVideo } from 'widget/redux/client/actions/change-playback-status';
import { selectVideo } from 'widget/redux/client/actions/select-video';

import {
  openFullScreenOverlay,
  openFullScreenPurchaseOverlay,
  openFullScreenMemberOnlyOverlay,
  openFullScreenSubscribeOverlay,
} from 'shared/utils/open-overlay';


@connect(null, {
  playVideo,
  selectVideo,
})
export default class InFrameActionCallbacks extends React.Component {

  static propTypes = {
    children: React.PropTypes.element.isRequired,
    selectVideo: React.PropTypes.func.isRequired,
    playVideo: React.PropTypes.func.isRequired,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
  };

  @autobind
  selectVideo() {
    const { selectVideo, videoId } = this.props;
    return selectVideo(videoId);
  }

  @autobind
  playVideo() {
    const { playVideo, videoId } = this.props;
    return playVideo(videoId);
  }

  @autobind
  @notForPreview
  showVideoAtOverlay() {
    const { channelId, videoId } = this.props;
    openFullScreenOverlay(`#/channel/${channelId}/video/${videoId}`);
  }

  @autobind
  @notForPreview
  showVideoMemberOnlyInfo() {
    const { channelId, videoId } = this.props;
    return openFullScreenMemberOnlyOverlay(channelId, videoId);
  }

  @autobind
  @notForPreview
  showVideoPurchaseInfo() {
    const { channelId, videoId } = this.props;
    return openFullScreenPurchaseOverlay(channelId, videoId);
  }

  @autobind
  @notForPreview
  showChannelSubscriptionInfoAtOverlay() {
    openFullScreenSubscribeOverlay(this.props.channelId);
  }

  render() {
    return React.cloneElement(this.props.children, {
      onClick: this.selectVideo,
      onPlayRequest: this.playVideo,
      onPlayMemberOnlyRequest: this.showVideoMemberOnlyInfo,
      onPlayWithoutPreviewRequest: this.showVideoAtOverlay,
      onPurchaseRequest: this.showVideoPurchaseInfo,
      onSubscriptionRequest: this.showChannelSubscriptionInfoAtOverlay,
    });
  }
}




// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/actions/overlay-action-callbacks/in-frame.js